import React, { type ButtonHTMLAttributes, type DetailedHTMLProps, type ReactElement, type HTMLProps, cloneElement, forwardRef, Children } from "react";
import { twMerge, twJoin } from "tailwind-merge";

interface IconButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  active?: boolean;
  activeIcon?: ReactElement<HTMLProps<SVGSVGElement>>;
  activeClassName?: string;
  children: ReactElement<HTMLProps<SVGSVGElement>>;
}

export const SupIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { active = false, children, activeIcon = children, className, activeClassName = "fill-neutral-800", ...restProps },
  ref
) {
  const icon = Children.only(children);

  return (
    <button ref={ref} {...restProps}>
      {active
        ? cloneElement(activeIcon, { className: twMerge("sup-icon-button", activeIcon.props.className, activeClassName, className) })
        : cloneElement(icon, { className: twJoin("sup-icon-button", icon.props.className, className) })}
    </button>
  );
});
